import * as firebase from "firebase";
import 'firebase/firestore';
import 'firebase/storage';
import 'firebase/auth';

const configOptions = {
    apiKey: "AIzaSyCz6EQyCaEK9Guw2cQlK1ma0Zkt1OUMTzo",
    authDomain: "dentalref-c4e08.firebaseapp.com",
    databaseURL: "https://dentalref-c4e08.firebaseio.com",
    projectId: "dentalref-c4e08",
    storageBucket: "dentalref-c4e08.appspot.com",
    messagingSenderId: "879348504705",
    appId: "1:879348504705:web:28c8470a8fad75d19fd580",
    measurementId: "G-0YCG82KZM1"
  };
firebase.initializeApp(configOptions);
firebase.analytics();

const db = firebase.firestore();
const storage = firebase.storage();
const functions = firebase.functions();
db.settings({});

//This will eventually have to output the firebase storage and auth objects as well to fix storage reference and auth reference

export default { db, storage, functions }; 